import { consumeSSE } from "@/utils/api";
import { BaseStreamConsumer } from "./base";
import sleep from "sleep-promise";
import { EntityRepository } from "../entity_repository";


export class SSEStreamConsumer extends BaseStreamConsumer {
    url: string;
    args: any;
    _ac: any | null = null;

    constructor(url: string, args: any, repositoryMapping: {[key: string]: EntityRepository<any>}) {
        super(repositoryMapping);
        this.url = url;
        this.args = args;
    }

    async _consume() {
        while (true) {
            let streamArgs = {...this.args};
            if (this.resumeToken) {
                streamArgs["resume_token"] = this.resumeToken;
            }
            let argsPart = (new URLSearchParams(streamArgs)).toString();
            this._ac = new AbortController();
            this.timeStarted = +Date.now();
            await consumeSSE(`${this.url}?${argsPart}`, this._processEvent.bind(this), this._ac.signal);
            await sleep(1000);
        }
    }

    _close() {
        this._ac.abort();
    }
}
